import { FlexBox } from '@dixa/lib-shared-habla';
import { Field } from 'redux-form';

import { FormSectionTitle } from 'components/settings/components/sections/dixaMessenger/views/appearance/components/formSectionTitle';
import { messengerSettingsFormFields } from 'components/settings/components/sections/dixaMessenger/views/appearance/types';

import { LauncherIconPickerField } from './components/LauncherIconPickerField';
import {
  DefaultBrandedDixaLauncherIcon,
  UnbrandedDixaLauncherIcon,
} from './components/icons';
import { LauncherIconOption } from './types';

export function LauncherIcon(): JSX.Element {
  const availableLauncherIcons: LauncherIconOption[] = [
    {
      id: 'dixa-branded-default',
      icon: <DefaultBrandedDixaLauncherIcon style={{ display: 'block' }} />,
      title: 'Dixa icon',
      lockedFeature: false,
    },
    {
      id: 'chat-bubbles',
      icon: <UnbrandedDixaLauncherIcon style={{ display: 'block' }} />,
      title: 'Chat bubbles',
      lockedFeature: false,
    },
  ];

  return (
    <div>
      <FormSectionTitle
        title={
          <FlexBox alignItems="center" gap="200">
            Custom Launcher icon
          </FlexBox>
        }
        description="Select which launcher icon you want to display for your Messenger"
      />

      <Field
        options={availableLauncherIcons}
        component={LauncherIconPickerField}
        name={messengerSettingsFormFields.launcherIconType}
      />
    </div>
  );
}
